import { Form, Button, ListGroup, Badge } from 'react-bootstrap'

const AccountSelector = ({ selectedAccounts, onAccountSelectionChange, accounts }) => {
  const accountList = Object.keys(accounts)

  const handleAccountToggle = (accountKey) => {
    const newSelection = selectedAccounts.includes(accountKey)
      ? selectedAccounts.filter(key => key !== accountKey)
      : [...selectedAccounts, accountKey]
    onAccountSelectionChange(newSelection)
  }

  const handleSelectAll = () => {
    onAccountSelectionChange(accountList)
  }

  const handleSelectNone = () => {
    onAccountSelectionChange([])
  }

  return (
    <div>
      {/* 批量选择按钮 */}
      <div className="d-flex gap-2 mb-3">
        <Button 
          variant="outline-primary" 
          size="sm" 
          onClick={handleSelectAll}
          disabled={accountList.length === 0}
        >
          全选 ({accountList.length})
        </Button>
        <Button 
          variant="outline-secondary" 
          size="sm" 
          onClick={handleSelectNone}
          disabled={selectedAccounts.length === 0}
        >
          清空
        </Button>
      </div>

      {/* 账号列表 */}
      {accountList.length === 0 ? (
        <div className="text-center text-muted py-3">
          <p>暂无可用账号</p>
          <small>请先在账号管理页面添加账号</small>
        </div>
      ) : (
        <ListGroup style={accountList.length > 5 ? { maxHeight: 330, overflowY: 'auto' } : undefined}>
          {accountList.map(accountKey => {
            const account = accounts[accountKey]
            const isSelected = selectedAccounts.includes(accountKey)
            
            return (
              <ListGroup.Item
                key={accountKey}
                action
                active={isSelected}
                onClick={() => handleAccountToggle(accountKey)}
                className={`account-selector-item d-flex justify-content-between align-items-center ${isSelected ? 'active' : ''}`}
              >
                <div className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => handleAccountToggle(accountKey)}
                    onClick={(e) => e.stopPropagation()}
                    className="me-2"
                  />
                  <div>
                    <div className="fw-bold">{account.username}</div>
                    <small className="text-muted">
                      {account.server}
                      {account.userInfo?.nickname && ` • ${account.userInfo.nickname}`}
                      {account.userInfo?.level && ` • Lv.${account.userInfo.level}`}
                    </small>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-end">
                  <Badge bg="success" className="mb-1">在线</Badge>
                  {account.userInfo?.vip > 0 && (
                    <Badge bg="warning">VIP{account.userInfo.vip}</Badge>
                  )}
                </div>
              </ListGroup.Item>
            )
          })}
        </ListGroup>
      )}

      {/* 选择统计 */}
      {selectedAccounts.length > 0 && (
        <div className="mt-3 p-2 bg-light rounded">
          <small className="text-muted">
            已选择 {selectedAccounts.length} 个账号
          </small>
        </div>
      )}
    </div>
  )
}

export default AccountSelector
